import React from "react";
import { mapCompanyToBotmarkInfo } from "../../utils/botmarkCompanyInfo";
import { useBotmarkCompanyInfo } from "../../hooks/useCompanies";

function HomeContact(){
    const { data: botmarkCompany } = useBotmarkCompanyInfo();
    const info = mapCompanyToBotmarkInfo(botmarkCompany);

    return(
        <div>
            <div style={{width:"100%",backgroundColor:"#212121"}}>
                <div style={{display:"flex", flexDirection:"column", marginLeft: "20px", justifyContent:"end", paddingTop:"20px", marginLeft:"10%"}}>
                    <h1 style={{textAlign:"Left", margin:"0px", color:"white", marginBottom:"20px"}}>Get In Touch</h1>
                    <h3 style={{color:"darkgrey", textAlign:"Left", margin:"0px", marginTop:"5px", color:"white"}}>Office Address</h3>
                    <p style={{margin:"", textAlign:"left", color:"lightgray"}}>
                        {info.street}
                        <br/>
                        {info.city}{info.city && info.zip ? ', ' : ''}{info.state} {info.zip}
                    </p>
                    <h3 style={{color:"darkgrey", textAlign:"Left", margin:"0px", marginTop:"5px", color:"white", marginTop:"20px"}}>Employee Contact</h3>
                    <div style={{margin:"", textAlign:"left", color:"lightgray", display:"flex", flexDirection:"column", paddingBottom:"20vh"}}>
                    <h4><b>Dean Onchuck</b></h4>
                    <i>Sales</i>
                    <br/>
                    {info.email}
                    <br/>
                    {info.phoneNumber}
                    <br/>
                    <br/>

                    <h4><b>Arnel Onchuck</b></h4>
                    <i>Operations Manager</i>
                    <br/>
                    layout@layoutspecialties.com
                    <br/>
                    (701) 640-3961
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeContact;
